import React from 'react';

const IconPaymentModalCheckmark = (props: { color?: string }): JSX.Element => (
  <svg style={{ marginRight: 7, marginBottom: 1 }} width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 5L5 9L13 1" stroke={props.color || 'var(--000000)'} strokeMiterlimit="10" strokeLinecap="square"/>
  </svg>
);

export default IconPaymentModalCheckmark;
